import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-EDM-maintain",
  "use": "icon-EDM-maintain-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-EDM-maintain\"><defs><style type=\"text/css\"></style></defs><path d=\"M961.344 139.136V1024H64.832V459.264l250.304-320.128h646.208z m-85.312 85.312H372.8L150.144 505.344v433.28h725.888V224.512zM595.2 446.72l69.056 50.112-188.096 258.88-69.056-50.112 188.16-258.88zM876.032 0v85.312H571.904V0h304.128z\" p-id=\"6769\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol